// import * as actionTypes from "../actions/actionTypes";
import { api } from "../../common/api-utils";

// // List View actions
// const getSubpanelListViewRequest = () => ({
//   type: actionTypes.SUBPANEL_LIST_VIEW_REQUEST,
// });

// const getSubpanelListViewSuccess = (payload, tab) => ({
//   type: actionTypes.SUBPANEL_LIST_VIEW_SUCCESS,
//   payload,
//   tab,
// });

// const getSubpanelListViewFailure = (error) => ({
//   type: actionTypes.SUBPANEL_LIST_VIEW_FAILURE,
//   error,
// });

// export const getSubpanelListView = (module, id, subpanel) => async (dispatch) => {
//   try {
//     dispatch(getSubpanelListViewRequest());
//     let filter = "?subpanel=documents";

//     const res = await api.get(`/V8/layout/Subpanel/${module}/${id}${filter}`);
//     //console.log(res);
//     if (res.ok) {
//       dispatch(getSubpanelListViewSuccess(res.data, module));
//       return;
//     }
//     dispatch(getSubpanelListViewFailure(res.data.errors.detail));
//   } catch (e) {
//     console.log(e);
//     dispatch(getSubpanelListViewFailure(e));
//   }
// };

export const getSubpanelListViewData = async (
  module,
  subpanel,
  subpanel_module,
  id,
  pageSize = 5,
  pageNo,
  name,
  order
) => {
  // console.log(module)
  // console.log(subpanel)
  // console.log(subpanel_module)
  // console.log(id)
  // console.log(pageSize)
  // console.log(pageNo)   
  try {
    if(pageNo)
    {
      let filter =
        "?subpanel=" +
        subpanel.toLowerCase() +
        "&subpanel_module=" +
        subpanel_module;
      filter = `${filter}&page[size]=${10}&page[number]=${pageNo}`;
      if (name) {
        filter = `${filter}&subpanel_sort=${name}`;
      }
      if (order) {
        filter = `${filter}&subpanel_sort_order=${order.toUpperCase()}`;
      }
      return await api.get(`/V8/layout/Subpanel/${module}/${id}${filter}`);
    }
  } catch (ex) {
    return ex;
  }
};

export const deleteRelationship = async (module, id, relationshipName, relateId,rel) => {
  // alert("DISPATCHED")
  // console.log(module)
  // console.log(id)
  // console.log(relationshipName)
  // console.log(relateId)
  // console.log(rel)
  // alert(`Rel in actions ${rel}`)
  try {
    return await api.delete(`/V8/module/${module}/${id}/relationships/${rel}/${relateId}`);
    // console.log(res?.data);
    // return res?.data;
  } catch (ex) {
    console.log(ex)
    return ex;
  }
};
export const closeActivity = async (submitData) => {
  
  try {
    return await api.patch(`/V8/module`, submitData);
				
  } catch (ex) {
    return ex;
  }
};
export const setRelationship = (tab, id, param) => async (dispatch) => {
  try {
    let res = {};
    res = await api.post(`/V8/module/${tab}/${id}/relationships`, param);
    if (res.ok) {
      return res.data;
    }
  } catch (e) {
    return e;
  }
};